import superagent from 'superagent'
import isNil from 'lodash/isNil'

export const speciesSet = types => ({
  type: 'SPECIES_SET',
  payload: types
})

export const speciesFetchRequest = () => (dispatch, getState, token) => {
  const species = getState().species
  return !isNil(species) && species.length > 0 ? Promise.resolve(species) :
    new Promise(resolve => {
      superagent
        .get(`${__API_URI__}/species/get?folder=small75`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (!res) return resolve(null)
          if (err) return resolve(null)
          resolve(res.body)
          dispatch(speciesSet(res.body))
        })
    })
}
